import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=28dbcaca&scoped=true"
import script from "./Pagination.vue?vue&type=script&setup=true&lang=js"
export * from "./Pagination.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Pagination.vue?vue&type=style&index=0&id=28dbcaca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dbcaca",
  null
  
)

export default component.exports